module.exports = __webpack_public_path__ + "static/img/model_bg@2x.d3ab6529.png";